import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "py-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-white capitalize" }, "Dashboard")
], -1)
const _hoisted_2 = { class: "bg-white flex flex-col shadow rounded-lg mt-6 divide-y" }
const _hoisted_3 = { class: "px-4 md:px-6 py-5 flex justify-between items-center" }
const _hoisted_4 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_5 = { class: "px-4 md:px-6 py-5 pb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 mb-3" }, "Search our trusted lender network to find the perfect fit for your needs", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, "Welcome, " + _toDisplayString(_ctx.profile.firstName || _ctx.profile.fullName || _ctx.profile.email) + "!", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_router_link, {
          to: { name: 'originators'},
          class: "text-white bg-sky font-medium px-4 py-2 rounded-md inline-block"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Find your match ")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}